import { useEffect, useState } from 'react'
import { Subscription } from 'rxjs'
import { getResourceObservable } from '../storage'
import { Entity, ResourceType } from '../types'

/**
 * Retrieves and subscribes to an observable resource of a given type. The underlying registry
 * relies on RXJS observables for keeping subscribers up to date.
 *
 * @param _type - The type of the resource.
 * @param id - The ID of the resource.
 *
 * @returns The resource of the given type, or null if it doesn't exist.
 */
export default function useResource<T extends ResourceType>(_type: T, id: string) {
  const observable = getResourceObservable<T>(id)

  const [resource, setResource] = useState<Entity<T> | null>(observable?.getValue())

  useEffect(() => {
    let subscription: Subscription | undefined

    setResource(observable?.getValue())

    if (observable) {
      subscription = observable.subscribe((data) => {
        setResource(data)
      })
    }

    return () => {
      subscription?.unsubscribe()
    }
  }, [observable, id])

  return resource
}
